/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Voice_ModerateInputs */

const en_dialog_voice_moderate = /** @type {(inputs: Dialog_Voice_ModerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moderate voice`)
};

const es_dialog_voice_moderate = /** @type {(inputs: Dialog_Voice_ModerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voz moderada`)
};

/**
* | output |
* | --- |
* | "Moderate voice" |
*
* @param {Dialog_Voice_ModerateInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_voice_moderate = /** @type {((inputs?: Dialog_Voice_ModerateInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Voice_ModerateInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_voice_moderate(inputs)
	return en_dialog_voice_moderate(inputs)
});